// ─────────────────────────────────────────────────────────────────────────────
// Topbar — header with optional "Back to merchant site" link and the
// Posteering wordmark.
//
// The back-link is conditionally rendered based on returnUrl. Per Session
// 50 handoff and BFF contract: returnUrl=null means the creator didn't
// supply one, so we must not render a link at all (not even a dead link
// that goes "somewhere reasonable"). Posteering doesn't know where "back"
// should point if the creator didn't say.
//
// The back-link opens in the same tab (no target="_blank"). The payer
// came from the merchant; sending them back means leaving the checkout.
// That's the correct behavior — this terminal action ends the session.
// ─────────────────────────────────────────────────────────────────────────────

export interface TopbarProps {
  returnUrl: string | null;
}

export function Topbar({ returnUrl }: TopbarProps) {
  return (
    <header className="topbar">
      {returnUrl ? (
        <a href={returnUrl} className="back-link" rel="noopener">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path
              d="M19 12H5M12 19l-7-7 7-7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Back to merchant site
        </a>
      ) : (
        // Empty span keeps justify-content:space-between working so the
        // wordmark stays right-aligned even when the back-link is hidden.
        <span />
      )}

      <a href="/" className="brand" aria-label="Posteering">
        <img src="/logo-wordmark.png" alt="Posteering" />
      </a>
    </header>
  );
}
